export const MAXIMUM_CHAR_COUNT = ({ message }) => ({
  max: 75,
  message,
});
